<template>
  <div class="txt_c" style="padding:30px 30px 10px;">
    <div class="scaling-squares-spinner">
      <div class="square"></div>
      <div class="square"></div>
      <div class="square"></div>
      <div class="square"></div>
    </div>
    <div class="mt20 dwms_loading_txt">ES KIOSK 로그인 처리중입니다.</div>
  </div>
</template>

<script>
import ApiUtil from "@/api/api.util";
import ApiConfig from "@/api/api.config";
import {store} from "@/store";

export default {
  name: "SsoLogin",
  mounted() {
    // 계정정보(info)는 더 이상 URL 로 넘어오지 않는다.
    // ebmp-saml-sso → API(ssoBridge)가 서버에 저장한 뒤, URL 에는 일회용 key 만 실어서 넘어온다.
    const urlParams = new URLSearchParams(window.location.search)
    this.sso.key = urlParams.get('key')

    if (!this.sso.key) {
      kendo.alert('SSO 인증 정보가 없습니다. 다시 로그인해주세요.')
      return false
    }

    setTimeout(() =>
      this.$nextTick(() => {
        this.onSubmit()
      })
      ,2000) // 임시
  },
  methods: {
    onSubmit () {
      const vm = this
      const loginParams = {
        key: vm.sso.key,
      }

      // 일회용 key 로 로그인 처리 (실제 계정정보는 서버 메모리에만 존재)
      ApiUtil.post(`${ApiConfig.eklDomain}/v1/ebmp/ai/manager/auth/ssoLoginByKey.json`, loginParams).then(function (response) {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터가 정상적으로 처리되지 않았습니다.')
          return false
        }
        if (response.data.resultStatus.messageCode !== '2000') {
          kendo.alert(response.data.resultStatus.messageText)
          return false
        }

        /**
         * 로그인 성공 시점
         *
         */
        let loginUserData = response.data.resultData
        let loginUserToken = loginUserData.loginUserToken

        const firstAccessParams = {
          loginUserToken: loginUserToken,
          responseMenuYn : 'Y',
          wmGbn: '02',
        }

        ApiUtil.post(`${ApiConfig.eklDomain}/v1/ebmp/ai/manager/auth/ssoAccessInfo.json`, firstAccessParams).then(function (response) {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터가 정상적으로 처리되지 않았습니다.')
            return false
          }

          if (response.data.resultStatus.messageCode !== '2000') {
            kendo.alert(response.data.resultStatus.messageText)
            return false
          }
          /**
           * firstAccessInfo 데이터 가져온 시점
           */
          let firstAccessInfoResultData = response.data.resultData
          const isFirstLogin = firstAccessInfoResultData.isFirstLogin

          sessionStorage.setItem('ssoUserToken', loginUserToken)
          sessionStorage.setItem('loginUserToken', loginUserToken)
          sessionStorage.setItem('isFirstLogin', isFirstLogin)
          sessionStorage.setItem('loginUserData', JSON.stringify(firstAccessInfoResultData))
          sessionStorage.setItem('userInfo', JSON.stringify(loginUserData))

          store.dispatch('initLogisticsData') // loginUserToken이 sessionStorage에 있어야 함
          setTimeout(() => {
            vm.$router.push({
              name: 'ReserveList',
            })
            // 임시: store 보다 mixin이 더 빨리 로딩되어서, 검색조건 세팅이 안된다.
          }, 2000)

        })
      })
    },
  },
  data () {
    return {
      sso: {
        key: ''
      }
    }
  }
}
</script>

<style scoped>

.dwms_loading_txt {
  font-size: 18px;
  font-weight: 500;
}
.scaling-squares-spinner, .scaling-squares-spinner * {
  box-sizing: border-box;
  margin:0 auto
}

.scaling-squares-spinner {
  height: 35px;
  width: 35px;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  animation: scaling-squares-animation 1250ms;
  animation-iteration-count: infinite;
  transform: rotate(0deg);
}

.scaling-squares-spinner .square {
  height: calc(35px * 0.25 / 1.3);
  width: calc(35px * 0.25 / 1.3);
  margin-right: auto;
  margin-left: auto;
  border: calc(35px * 0.04 / 1.3) solid #1E7FFE;
  position: absolute;
  animation-duration: 2250ms;
  animation-iteration-count: infinite;
}

.scaling-squares-spinner .square:nth-child(1) {
  animation-name: scaling-squares-spinner-animation-child-1;
}

.scaling-squares-spinner .square:nth-child(2) {
  animation-name: scaling-squares-spinner-animation-child-2;
}

.scaling-squares-spinner .square:nth-child(3) {
  animation-name: scaling-squares-spinner-animation-child-3;
}

.scaling-squares-spinner .square:nth-child(4) {
  animation-name: scaling-squares-spinner-animation-child-4;
}


@keyframes scaling-squares-animation {

  50% {
    transform: rotate(90deg);
  }

  100% {
    transform: rotate(180deg);
  }
}

@keyframes scaling-squares-spinner-animation-child-1 {
  50% {
    transform: translate(150%,150%) scale(2,2);
  }
}

@keyframes scaling-squares-spinner-animation-child-2 {
  50% {
    transform: translate(-150%,150%) scale(2,2);
  }
}

@keyframes scaling-squares-spinner-animation-child-3 {
  50% {
    transform: translate(-150%,-150%) scale(2,2);
  }
}

@keyframes scaling-squares-spinner-animation-child-4 {
  50% {
    transform: translate(150%,-150%) scale(2,2);
  }
}
</style>